var rands = [];
var randomText=  {
	max: 0,
	text: "",
	length: 0,
	baseText: "",
	texts: "abcdefghijklmnopqrstuvwxyz0123456789",
	init: function(){
		let txt = $("#brain_id h5");
		rands = [];
		randomText.baseText = txt.attr("data-text");
		randomText.length = randomText.baseText.length;
	},
	run: function(){
		let r = randomText;
		r.count = 0;
		//console.log(r.count, r.length)
		countUp();
		function countUp(){
			r.count++;
			if(r.count >= r.length){
				r.count = r.length -1;
				$("#brain_id h5").html(randomText.baseText);
			}else{
				var t = "";
				for(var i = 0; i < r.count; i++){
					t += randomText.texts[Math.floor(Math.random()*randomText.length)];
				}
				$("#brain_id h5").html(t);
				setTimeout(function(){
					countUp();
				},33);
			}
		}
	}
}